import React from 'react';
import ColorUtils from '../utils/colors';
import localization from '../utils/localization';
import { Paper, Box } from '@mui/material';
import moment from 'moment';

export function IndexCard(props) {
  return (
    <Paper elevation={0} sx={{
      backgroundColor: ColorUtils.white,
      width: '18rem',
      margin: '0.5rem auto',
      borderRadius: '16px',
      border: '1px solid rgba(0,0,0,0.06)',
      boxShadow: '0 6px 24px rgba(0,0,0,0.04)',
      transition: 'all 0.3s ease',
      overflow: 'hidden',
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-6px)',
        boxShadow: '0 15px 35px rgba(0,0,0,0.08)',
        borderColor: 'rgba(0,0,0,0.1)',
      }
    }}>
      <div style={{
        padding: '1.5rem 1.5rem 0.5rem',
        fontSize: '1.25rem',
        fontWeight: 700,
        color: ColorUtils.textColor,
      }}>{localization.strings.encryptedData}</div>
      <div style={{
        padding: '0.5rem 1.5rem 1.25rem',
        wordWrap: 'break-word',
        color: ColorUtils.textColorGrey,
        lineHeight: 1.6,
        fontSize: '0.95rem',
        fontFamily: 'monospace',
      }}>{props.pwd.encrypted_data}</div>
      <div style={{
        padding: '1rem 1.5rem',
        backgroundColor: 'rgba(0,0,0,.015)',
        borderTop: '1px solid rgba(0,0,0,.04)',
        fontSize: '0.85rem',
        color: ColorUtils.textColorGrey,
        display: 'flex',
        alignItems: 'center',
      }}>
        <i className="iconfont icon-clock" style={{ marginRight: '6px' }}></i>
        {localization.strings.passwordCreateTime}: {moment(props.pwd.last_modify_time*1000).format('YYYY-MM-DD HH:mm:ss')}
      </div>
    </Paper>
  )
}

export default IndexCard;